import { SoccerIncidentId } from '@collector/sportsapi-client-legacy'

export const incidentsRequireConfirmation = [
  SoccerIncidentId.Goal,
  SoccerIncidentId.Penalty,
  SoccerIncidentId.YellowCard,
  SoccerIncidentId.Corner,
  SoccerIncidentId.RedCard,
]
